import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@/icons";
import { theme } from "@/theme/theme";

const SearchTextField = ({
                             value,
                             onChange,
                             label = "Search",
                             placeholder = "Type to search",
                             inputProps,
                         }) => {
    return (
        <TextField
            variant="outlined"
            value={value}
            onChange={onChange}
            label={label}
            placeholder={placeholder}
            inputProps={inputProps}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                ),
            }}
            sx={{
                "@media (max-width: 1008px)": {
                    width: "100%",
                },
            }}
        />
    );
};

export default SearchTextField;
